import { ReactElement } from 'react';

import { IconFillColor, IconWrapper, ShieldIcon, ShieldProtectedIcon, StyledFlex } from '@dreryk/react-components';
import { Translate } from '@dreryk/react-common';

import { visitTranslationKeys } from '../../translations';

type VisitConfidentialityTextProps = {
   readonly restricted: boolean;
};

export const VisitConfidentialityText = (props: VisitConfidentialityTextProps): ReactElement => {
   return (
      <StyledFlex alignItems={'center'} gap={'4px'}>
         <IconWrapper testId={'confidentiality'} fillColor={IconFillColor.BACKGROUND}>
            {props.restricted ? <ShieldProtectedIcon /> : <ShieldIcon />}
         </IconWrapper>
         <Translate>
            {props.restricted
               ? visitTranslationKeys.controlsBar.visitConfidentialityLevel.CONFIDENTIAL
               : visitTranslationKeys.controlsBar.visitConfidentialityLevel.NORMAL}
         </Translate>
      </StyledFlex>
   );
};
